"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = exports.LIMIT_EXCEEDED_ERROR = void 0;
/* eslint-disable */
const isObj = (obj) => Object.prototype.toString.call(obj) === "[object Object]";
const isEmptyString = (s) => String(s) === "";
/**
 * This string constant is returned as the value of a error property
 * if the flatten operation exceeds the maximum number of keys.
 * By returning a object with a fixed key/value pair we can indentify
 * the error sitation in arguslogs and improve the logging statement.
 */
exports.LIMIT_EXCEEDED_ERROR = "logging/flatten: Limit exeeded";
/**
 * Takes a potentially deeply nested object and flattens every path using
 * a separator (default .) and a prefix (default "").
 *
 * ```typescript
 * flatten({ a: {b: "c" } }) => { "a.b": "c" }
 * ```
 *
 * @param initial The object to flatten
 * @param opts    How to flatten
 */
const flatten = (initial, opts = {}) => {
    if (initial === undefined || initial === null)
        return {};
    const { separator = ".", prefix = "", limit = 250 } = opts;
    const results = {};
    function iterator(obj, localPrefix, flattened) {
        if (Array.isArray(obj)) {
            obj.forEach((item, idx) => {
                iterator(item, [localPrefix, idx].filter((s) => !isEmptyString(s)).join(separator), flattened);
            });
        }
        else if (obj instanceof Error) {
            iterator({ name: obj.name, message: obj.message, stack: obj.stack }, localPrefix, flattened);
        }
        else if (isObj(obj)) {
            Object.entries(obj).forEach(([k, v]) => {
                iterator(v, [localPrefix, k].filter((s) => !isEmptyString(s)).join(separator), flattened);
            });
        }
        else if (typeof obj === "number" || obj === null) {
            flattened[localPrefix] = obj;
        }
        else {
            flattened[localPrefix] = String(obj);
        }
    }
    iterator(initial, prefix, results);
    if (Object.keys(results).length > limit) {
        return {
            error: exports.LIMIT_EXCEEDED_ERROR,
        };
    }
    return results;
};
exports.flatten = flatten;
